<template>
	<!-- Old UI -->
	<el-card class="mt-3 updated-store-settings-non-cov-activities br-12">
		<el-row :gutter="20">
			<el-col :span="18">
				<h2 v-if="checkCompany.is_mcd || checkCompany.is_mcd_north" class="my-2">Fixed / Non-Coverage Activities</h2>
				<h2 v-else class="my-2">Non-Coverage Activities</h2>
				<p>
					All non-coverage activities
				</p>
			</el-col>
			<el-col :span="6" class="text-right">
				<!-- <div class="text-right pt-8">
					<el-button type="warning" plain size="small" icon="el-icon-circle-plus-outline" class="primary-settings-button"
						@click="openNonCoverageActivity">Add New</el-button>
				</div> -->
				<!-- View Hourly Button Commented For Future Development -->
				<el-button type="warning" plain icon="el-icon-alarm-clock" class="primary-settings-button" size="small" @click="openHourlyView">
					View Hourly
				</el-button>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="mt-2">
			<el-col :span="24">
				<el-table
					:data="row_wise_company_non_coverage_activities"
					style="width: 100%"
					max-height="400"
					row-class-name="custom-non-cov-cell"
				>
					<el-table-column prop="name" label="Section"></el-table-column>
					<el-table-column label="Station / Function">
						<template slot-scope="scope">
							<span  @click="((hasAdminAccess || postOnboardingAccess) || postOnboardingAccess) ? toggleNonCoverageStation(scope.row.store_section, scope.row.function) : ''">
								<primary-tag v-if="scope.row.enabled" slot="reference" :class="[((hasAdminAccess || postOnboardingAccess) || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']">
									<span class="pr-1" :class="[((hasAdminAccess || postOnboardingAccess) || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-check"></i></b></span>{{ scope.row.function_name }}
								</primary-tag>
								<secondary-tag v-else-if="!scope.row.enabled" slot="reference" :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']">
									<span class="pr-1" :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-close"></i></b></span>{{ scope.row.function_name }}
								</secondary-tag>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="Activities">
						<template slot-scope="scope">
							<template
								v-if="scope.row.non_coverage_activities && scope.row.non_coverage_activities.length"
							>
								<el-row v-for="(activityItem, activityIndex) in scope.row.non_coverage_activities" :key="'activity-item-'+activityIndex" :gutter="20" class="mb-3">
									<el-col :span="24">
										<span @click="(hasAdminAccess || postOnboardingAccess) ? (activityItem.enabled = !activityItem.enabled, enableDisableDailyActivity(activityItem.enabled, activityItem.id)) : ''">
											<activity-tag v-if="activityItem.enabled" :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']">
												<span class="pr-1" :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-check"></i></b></span>{{ activityItem.activity_name }}
											</activity-tag>
											<inactive-activity-tag v-else :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']">
												<span class="pr-1" :class="[(hasAdminAccess || postOnboardingAccess) ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-close"></i></b></span>{{ activityItem.activity_name }}
											</inactive-activity-tag>
										</span>
									</el-col>
									<!-- <el-col :span="12">
										<div class="text-right" style="padding-right: 15px;">
											<span>
												<img
													src="../../../../../assets/icons/edit-icon.svg"
													width="12"
													class="cursor-pointer"
													@click="openEditSectionNonCoverageActivity(activityItem)"
												/>
											</span>
										</div>
									</el-col> -->
								</el-row>
								<!-- <span v-for="(activityItem, activityIndex) in scope.row.non_coverage_activities" :key="'activity-item-'+activityIndex" @click="activityItem.enabled = !activityItem.enabled; enableDisableDailyActivity(activityItem.enabled, activityItem.id);">
									<activity-tag v-if="activityItem.enabled">
										<span class="pr-1 cursor-pointer"><b><i class="el-icon-check"></i></b></span>{{ activityItem.activity_name }}
									</activity-tag>
									<inactive-activity-tag v-else>
										<span class="pr-1 cursor-pointer"><b><i class="el-icon-close"></i></b></span>{{ activityItem.activity_name }}
									</inactive-activity-tag>
								</span> -->
							</template>
							<template v-else>
								&#8212;
							</template>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<section-and-station-mapping></section-and-station-mapping>
	</el-card>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin';
// import AddOrEditNonCoverageActivity from '../companySettings/AddOrEditNonCoverageActivity.vue';
import PrimaryTag from '../companySettings/PrimaryTag.vue';
import SecondaryTag from '../companySettings/SecondaryTag.vue';
import SectionAndStationMapping from '../companySettings/SectionAndStationMapping.vue';
import ActivityTag from '../companySettings/ActivityTag.vue';
import InactiveActivityTag from "../companySettings/InactiveActivityTag.vue";
export default {
	name: "StoreNonCoverageActivities",
	components: {
		PrimaryTag,
		// AddOrEditNonCoverageActivity,
		SectionAndStationMapping,
		SecondaryTag,
		ActivityTag,
		InactiveActivityTag
	},
	mixins: [settingsMixin]
}
</script>

<style lang="scss">
/* .updated-store-settings-non-cov-activities {
} */
.action-popover {
	min-width: fit-content !important;
	width: auto !important;
	text-align: center !important;
}
.light-border-bottom {
	/* border-bottom: 1px solid #BFC0C4;
	border-left: 1px solid #BFC0C4; */
	padding: 15px;
	padding-left: 0;
	padding-right: 0;
}
.equal-text {
	font-size: 12px;
}
.el-table__row.custom-non-cov-cell {
	td.el-table__cell {
		vertical-align: top !important;
	}
}
</style>